import { render, staticRenderFns } from "./generic-node.vue?vue&type=template&id=32604b4f"
import script from "./generic-node.vue?vue&type=script&lang=js"
export * from "./generic-node.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports